import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import { DASHBOARDS_FORMS } from '../../../constants';
import { renderBarContent } from '../renderers/barRenderer';
import { transformScheduleComplianceData } from '../transformers/scheduleComplianceTransformer';

import type { WidgetConfig } from './types';

export const scheduleComplianceChartConfig: WidgetConfig = {
  collectionName: FSCollections.BAR_CHARTS,
  componentType: DASHBOARDS_FORMS.SCHEDULE_COMPLIANCE,
  op: API_OPERATIONS.SCHEDULES_COMPLIANCE,

  buildParams: (queryParams, commonParams) => ({
    ...commonParams,
    userIds: queryParams.userIds,
    groupIds: queryParams.groupIds,
    scheduleIds: queryParams.scheduleIds,
    divisionIds: queryParams.divisionIds,
    templateIds: queryParams.templateIds,
    type: queryParams.type,
    valueType: queryParams.valueType,
    groupBy: queryParams.groupBy,
  }),
  renderContent: renderBarContent,
  transformData: transformScheduleComplianceData,
};
